import { ApiError } from "../lib/api";
import type { TFn } from "./index";

// Known backend error codes that have a dedicated localized message.
const KNOWN_CODES = new Set([
  "existing_client",
  "nick_taken",
  "already_in_clan",
  "clan_not_found",
  "participant_not_found",
  "not_eligible",
  "bad_start_date",
  "no_hw_event_for_date",
  "rate_limited",
  "forbidden_for_role",
  "not_registered",
]);

/**
 * Map a thrown value (ApiError / Error) OR a raw backend code string to a
 * localized, user-facing message. Known backend error codes get a dedicated
 * translation; everything else falls back to a generic localized
 * "something went wrong".
 *
 * Pass `fallbackKey` to override the generic fallback for a specific flow.
 */
export function errorMessage(e: unknown, t: TFn, fallbackKey = "error.generic"): string {
  let code: string | null = null;
  if (e instanceof ApiError) {
    code = e.code;
  } else if (typeof e === "string") {
    code = e;
  }

  if (code && KNOWN_CODES.has(code)) {
    return t(`error.${code}`);
  }
  return t(fallbackKey);
}
